import { CircularProgress } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";

import i18next from "i18next";
import { BuildingsPage } from "../BuildingsPage/BuildingsPage";
import { ClientConfPage, ClientListPage } from "../ClientPages";
import { TicketsPage } from "../ClientPages/TicketsPage";
import CookiePopup from "../MainPage/CookiePopup";
import { TasksPage } from "../Pages/TasksPage";
import { PartPage } from "../PartPage/PartPage";
import { StatPage } from "../PartPage/StatPage";
import { AnketaFieldsPage } from "../Pages/AnketaFieldsPage";
import { OrdersPage } from "../Pages/OrdersPage";
import { MailingsPage } from "../Pages/MailingsPage";
import { SpeakersPage } from "../SpeakersPage/SpeakersPage";
import { SponsorPage } from "../SponsorPage/SponsorPage";
import { RolePage } from "../TeamPage/RolePage";
import { TeamPage } from "../TeamPage/TeamPage";
import { UserListPage } from "../UserListPage/UserListPage";
import { history, store } from "../_helpers";
import { LANG_LIST } from "../_constants";
import { confService, userService } from "../_services";
import { ConfListPage } from "./ConfListPage";
import { ConfNavPage } from "./ConfNavPage";
import { CreateConfPage } from "./CreateConfPage";
import { VoteListPage } from "../VotePage/VoteListPage";
import { CreateVotePage } from "../VotePage/CreateVotePage";
import { SettingsPage } from "./SettingsPage";
import { SuppPage } from "./SuppPage";

import { SiteListPage } from "../SitePage/SiteListPage";
import { CreateSitePage } from "../SitePage/CreateSitePage";
import { BookingPage } from "../RentPage/BookingPage";
import { RentListPage } from "../RentPage/RentListPage";
import { RentViewPage } from "../RentPage/RentViewPage";

import { Snack } from "../_components";
import "../css/style.css";
import "../css/responsive.css";
import "../fonts/fonts.css";

import TimeTable from "../TimePage/TimeTable";
import { appActions, userActions } from "../_actions";
import { AppMenu } from "../_components/AppMenu";
import { HeadMenu } from "../_components/HeadMenu";
import { showGlobalSnackbar } from "../_services/snackbarService";

const USER_ORG = "org";
const USER_MEMBER = "team_member";
const USER_STUDENT = "student";
const USER_BLD = "building";
const USER_SUPERUSER = "superuser";

class MainPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      companies: [],
      hoverIndex: -1,
      isEdit: false,
      userType: "",
      userName: "",
      email: "",
      err_type: "error",
      menuOpen: window.innerWidth > 1400,
      loadConfInfo: false,
      loadTicketInfo: false,
      confInfo: null,
      tid: 0,
      confName: "",
      tickets: [],
      vertical: "top",
      horizontal: "center",
      confsLoaded: false,
      userInfoLoaded: false,
    };
    store.subscribe(this.storeChange);
  }

  storeChange = (e) => {
    const self = this;

    if (store.getState().user.error) {
      const err1 = `${store.getState().user.error}`;
      let err_tp = "error";
      let err_action = 0;

      let verify_notif_text = i18next.t("mail_aprrove_sending");

      if (store.getState().user.err_type)
        err_tp = store.getState().user.err_type;

      if (store.getState().user.err_action)
        err_action = store.getState().user.err_action;

      if (err1) {
        if (err_action != 1)
          this.setState({ snackText: err1, alertShow: true, err_type: err_tp });

        if (err_action == 1) {
          showGlobalSnackbar(i18next.t(err1), "warning");
          self.props.dispatch(userActions.disable_error());

          userService.postWrapper(
            "api/email/verification-notification",
            {},
            (data) => {
              showGlobalSnackbar(verify_notif_text, "info");
            },
            (error) => {
              console.log(error);

              if (error != "") {
                self.props.dispatch(
                  userActions.set_error(i18next.t("request_exec_error"))
                );
              }
            }
          );
        }
      } else
        this.setState({
          snackText: i18next.t("request_exec_error"),
          alertShow: true,
          err_type: "error",
        });

      setTimeout(() => {
        self.props.dispatch(userActions.disable_error());
      }, 100);

      if (err1.indexOf("401") >= 0 && err_tp == "error") history.push("/login");
    }

    if (store.getState().user.info && store.getState().user.info.type) {
      const userType = store.getState().user.info.type;

      this.setState({
        userType: userType,
        userName: store.getState().user.info.name,
        email: store.getState().user.info.email,
      });
    }

    // Локаль профиля главнее локали устройства: её человек выбрал сам в настройках,
    // и без этого выпадающий список языков там показывал одно, а интерфейс был на
    // другом. Режим «визитка» так делает давно (CardShell.applyProfileLocale),
    // кабинет — нет. Сравнение с текущим языком обязательно: setLanguage пишет
    // в стор, а мы подписаны на его изменения.
    const profileLocale = store.getState().user.info && store.getState().user.info.locale;
    // Сравнивать именно со стором, а не с this.props.app.lang: пропсы обновятся
    // только после ре-рендера, а сюда мы возвращаемся синхронно, из подписки на
    // стор. По пропсу язык остаётся прежним, условие снова истинно — и кабинет
    // уходит в рекурсию до «Maximum call stack size exceeded», отдавая пустой
    // экран каждому, у кого локаль профиля разошлась с localStorage.navic_lang.
    const currentLang = store.getState().app.lang;
    if (
      profileLocale &&
      profileLocale !== currentLang &&
      LANG_LIST.indexOf(profileLocale) >= 0
    ) {
      this.setLanguage(profileLocale);
    }
  };

  componentDidMount() {
    this.setLanguage(this.props.app.lang);

    const url = window.location.pathname;
    const self = this;

    let pp = this.props.match;
    console.log(pp);

    const userStrData = localStorage.getItem("user");

    if (userStrData && userStrData != "{}") {
      try {
        const objData = JSON.parse(userStrData);
        console.log(objData);
        if (objData && objData.id);
        this.props.dispatch(userActions.setuser(objData));
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log(userStrData);
      this.props.dispatch(userActions.getuser());
    }

    const strData = localStorage.getItem("conf");
    if (strData != "null" && strData) {
      try {
        const objData = JSON.parse(strData);
        if (objData && objData.id && objData.id != 0)
          this.props.dispatch(userActions.set_conf(objData));

        localStorage.removeItem("conf");
      } catch (e) {
        console.log(e);
      }
    }

    localStorage.setItem("navic_redirect_count", "");

   
      const url1 = url.replace("/", "");

      const urls = url1.split("/");
      let url0 = urls[0];

      let id = 0;
      if (urls.length > 1) id = urls[1];

      if (url0 == "") url0 = "confs";

      this.props.dispatch(appActions.setpage(url0, id));
   
  }

  setLanguage(language) {
    i18next.init({
      lng: language,
      resources: require(`../_lang/${language}.json`),
    });

    this.props.dispatch(appActions.setlang(language));
    localStorage.setItem("navic_lang", language);
  }

  getConfTicket = (name, tickets, conf_id) => {
    const { tid } = this.state;

    let tname = "";
    let tcost = "";

    for (let i = 0; i < tickets.length; i++) {
      if (tickets[i].id == tid) {
        tname = tickets[i].name;
        tcost = tickets[i].cost;
      }
    }

    if (tcost != "" && tcost > 0) {
      this.props.dispatch(
        userActions.set_error(
          i18next.t("you_bought_ticket") +
            " " +
            tname +
            " " +
            i18next.t("on_event") +
            " " +
            name,
          "info"
        )
      );
    } else {
      this.props.dispatch(
        userActions.set_error(
          i18next.t("you_reg_on_event") + " " + name,
          "info"
        )
      );
    }

    this.props.dispatch(appActions.setpage("conf_view", conf_id));
    // history.push('/conf_view/'+conf_id)
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  onCloseSnack = () => {
    this.setState({ alertShow: false });
  };

  clientMenuPress = (page) => {
    this.props.dispatch(appActions.setpage(page));
  };

  render() {
    const self = this;
    const {
      userType,
      userName,
      menuOpen,
      email,
      alertShow,
      snackText,
      err_type,
      vertical,
      horizontal,
    } = this.state;
    const { page } = this.props.app;
    const { user } = this.props;
    const isOverlay = window.innerWidth <= 1400;

    // <AppMenu menu={this.state.menu} selectedMenu={this.state.location} open={this.state.open}/>

    if (
      window.location.href.indexOf("ticket-moderation") >= 0 ||
      window.location.href.indexOf("votes") >= 0
    )
      return <div></div>;

    if (userType == USER_STUDENT) {
      return (
        <div>
          <HeadMenu
            name={userName}
            email={email}
            type={userType}
            menuPress={this.clientMenuPress}
          />
          <div className="layout_main">
            {userType == USER_STUDENT && page == "confs" && <ClientListPage />}
            {userType == USER_STUDENT && page == "conf_view" && (
              <ClientConfPage />
            )}
            {userType == USER_STUDENT && page == "tickets" && <TicketsPage />}
            {userType == USER_STUDENT && page == "partips" && (
              <PartPage conferenceId={0} />
            )}
            {userType == USER_STUDENT && page == "settings" && <SettingsPage />}
          </div>
        </div>
      );
    } else
      return (
        <div className="page-container">
          <AppMenu
            open={menuOpen}
            onOpen={() => self.setState({ menuOpen: !menuOpen })}
            onClose={() => self.setState({ menuOpen: false })}
            userType={userType}
            conf={user.selectedConf}
          />
          {isOverlay && menuOpen && (
            <div
              className="sidebar-backdrop"
              onClick={() => self.setState({ menuOpen: false })}
            />
          )}
          <div className={menuOpen && !isOverlay ? "wrapper__open" : "wrapper"}>
            <HeadMenu name={userName} email={email} type={userType} onMenuToggle={() => self.setState({ menuOpen: !menuOpen })} />
            <div className="layout_main">
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "events" && <ClientListPage />}
              {userType == USER_SUPERUSER &&
                (page == "userlist" || page == "confs") && <UserListPage />}

              {(userType == USER_ORG || userType == USER_MEMBER) &&
                (page == "confs" || page == "confs_title") && <ConfListPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "new_conf" && <CreateConfPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "conf_param" && <CreateConfPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "votelist" && <VoteListPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "newvote" && <CreateVotePage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "editvote" && <CreateVotePage />}

              {userType == USER_BLD && page == "confs" && <SiteListPage />}

              {userType == USER_ORG && page == "sites" && <RentListPage />}

              {userType == USER_BLD && page == "new_site" && <CreateSitePage />}

              {userType == USER_BLD && page == "booking" && <BookingPage />}

              {userType == USER_ORG && page == "booking" && <BookingPage />}

              {userType == USER_ORG && page == "site_view" && <RentViewPage />}

              {userType == USER_BLD && page == "site_param" && (
                <CreateSitePage />
              )}

              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "team_org" && (
                  <TeamPage
                    conf_id={user.selectedConf ? user.selectedConf.id : -1}
                  />
                )}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "role_org" && (
                  <RolePage
                    conf_id={user.selectedConf ? user.selectedConf.id : -1}
                  />
                )}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "client_view" && <ClientConfPage isOrg={true} />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "speakers" && <SpeakersPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "sponsors" && <SponsorPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "blds" && <BuildingsPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "partips" && <PartPage conferenceId={0} />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "confpartips" && (
                  <PartPage
                    conferenceId={user.selectedConf && user.selectedConf.id ? user.selectedConf.id : 0}
                    conf_name={user.selectedConf && user.selectedConf.id ? user.selectedConf.name : ""}
                    singleConf={true}
                  />
                )}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "nav" && <ConfNavPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "conf_prog" && (
                  <TimeTable
                    conf_data={user.selectedConf}
                    building_id={
                      user.selectedConf ? user.selectedConf.building_id : -1
                    }
                    conf_id={user.selectedConf ? user.selectedConf.id : -1}
                  />
                )}

              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "settings" && <SettingsPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "support" && <SuppPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "tasks" && <TasksPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "mailings" && <MailingsPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "anketa-fields" && <AnketaFieldsPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "orders" && <OrdersPage />}
              {(userType == USER_ORG || userType == USER_MEMBER) &&
                page == "statistics" && <StatPage />}
            </div>
          </div>
          <Snack
            open={alertShow}
            variant={err_type}
            text={snackText}
            onClose={this.onCloseSnack}
          />
          {user.isLoading && (
            <div className="shadow">
              <div className="shadow_circle">
                <CircularProgress />
              </div>
            </div>
          )}
          <CookiePopup />
        </div>
      );
  }
}

function mapStateToProps(state) {
  const { app, user, authentication } = state;

  return {
    user,
    app,
    authentication,
  };
}

const connectedMainPage = connect(mapStateToProps)(MainPage);
export { connectedMainPage as MainPage };
